import React from 'react'
import { Box, Typography } from '@material-ui/core';
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';

interface BarChartProps {
    chartOptions: ApexOptions;
    series: ApexAxisChartSeries;
    checked?: boolean;
    title?: string;
    chartWidth?: string;
    chartHeight?: string;
    headingStyle?: React.CSSProperties,
}

const BarChart = ({
    chartOptions,
    series,
    checked = false,
    title = '',
    chartHeight = '281px',
    chartWidth = '100%',
    headingStyle = {},
}: BarChartProps) => {
    return (
        <>
            {title && (
                <Typography style={{ ...webStyles.titleText, color: checked ? '#222222' : '#fff', ...headingStyle }}>
                    {title}
                </Typography>
            )}

            <Chart
                options={chartOptions}
                series={series}
                type="bar"
                width={chartWidth}
                height={chartHeight}
            />

            <Box style={webStyles.lengendContainer}>
                <Box style={webStyles.round} />
                <Typography style={{ ...webStyles.legendText, color: checked ? '#222222' : '#fff', }}>
                    Revenue
                </Typography>
            </Box>
        </>
    );
};

const webStyles = {
    titleText: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',
        marginBottom: '15px',
    },
    lengendContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '28px'
    },
    round: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        background: '#6200EA'
    },
    legendText: {
        fontSize: '10px',
        lineHeight: '12px',
        fontFamily: 'Manrope',
        fontWeight: 500,
    },
}


export { BarChart }